var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMirrorLeftRight = function SvgMirrorLeftRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 28,
    viewBox: "0 0 1.73 1.33",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26 1.16c-.05.04-.12.03-.17-.01A.135.135 0 0 1 1.1.98l.08-.07c.29-.25.28-.26.21-.32C1.34.56 1.31.53 1.27.5 1.22.45 1.18.41 1.11.36A.113.113 0 0 1 1.09.2c.03-.05.11-.07.16-.03.07.05.12.1.18.15.03.03.07.06.11.09.21.18.23.23.14.33 0 .01-.01.02-.02.03h-.01c0 .01-.01.02-.02.02-.1.13-.19.21-.29.3l-.08.07zm-.29.07c-.01.06-.07.11-.14.1-.06-.01-.1-.07-.09-.14V.98C.74.91.75.84.75.76c0-.07 0-.14.01-.2C.76.55.76.41.75.29V.15A.12.12 0 0 1 .83 0c.06-.01.13.03.14.09.01.02.01.1.02.2v.29C.99.64.98.7.98.76v.36c-.01.04-.01.08-.01.11zM.61.97c.06.03.07.11.04.16-.03.06-.11.07-.16.04-.03-.02-.06-.05-.11-.1C.3.98.19.86.08.78-.01.72-.02.66.03.58L.04.57C.06.54.09.53.12.51.15.49.18.47.2.45.25.4.34.32.43.25L.52.17C.57.13.64.13.68.18.73.23.72.3.67.35L.58.43C.5.49.41.57.37.61.35.63.33.65.31.66.4.74.49.84.55.91l.06.06z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgMirrorLeftRight;